import { apiFetch } from "../utils/apiFetch";
import { API_BASE_ADMIN } from "../config/vars";

export const fetchOperators = async () => {
    const response = await apiFetch(`${API_BASE_ADMIN}/operators/admin`);
    if (!response.ok) throw new Error("Не вдалося завантажити операторів");
    return response.json();
};

export const updateOperator = async (id, data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/operators/admin/${id}`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося оновити оператора");
    }
    return response.json();
};

export const addOperator = async (data) => {
    const response = await apiFetch(`${API_BASE_ADMIN}/operators/admin`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(data),
    });
    if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.detail || "Не вдалося додати оператора");
    }
    return response.json();
};
